var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlidersScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sliders_screen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 44,
    height: 39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3,
    y1: 7,
    x2: 43,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4,
    y1: 4,
    x2: 6,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7,
    y1: 4,
    x2: 9,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    y1: 4,
    x2: 12,
    y2: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 19,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 22,
    x2: 12,
    y2: 37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23,
    cy: 29,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23,
    y1: 11,
    x2: 23,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23,
    y1: 32,
    x2: 23,
    y2: 37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 34,
    cy: 23,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34,
    y1: 11,
    x2: 34,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34,
    y1: 26,
    x2: 34,
    y2: 37
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidersScreen);
export default __webpack_public_path__ + "static/media/sliders-screen.e313f2a28f18da42a4005a3b5ca38c08.svg";
export { ForwardRef as ReactComponent };